module.exports = __webpack_public_path__ + "media/images/dummy-content/user-6-1fb061e43f3b2260697c4907d2486d1c.jpg";